(() => {
 'use strict';
 function init() {
  const bar = document.getElementById('ri-mobile-product-bar');
  const nativeButton = document.getElementById('add-to-cart') || document.getElementById('mm-add');
  const form = nativeButton?.form;
  if (!bar || !form || bar.dataset.initialized) return;
  const professional = form.getAttribute('id') === 'mm-order-form';
  const total = document.getElementById(professional ? 'mm-total' : 'summary-incl');
  const quantity = document.getElementById(professional ? 'mm-quantity' : 'quantity');
  const summary = form.querySelector(professional ? '.mm-order-box' : '.order-summary');
  if (!total || !summary) return;
  const price = bar.querySelector('[data-product-bar-price]');
  const label = bar.querySelector('[data-product-bar-label]');
  const action = bar.querySelector('[data-product-bar-action]');
  const button = bar.querySelector('[data-product-bar-add]');
  const mobile = matchMedia('(max-width:650px)');
  let variants = window.RI?.variants || [];
  if (professional) {
   try { variants = JSON.parse(document.getElementById('mm-catalog-data').textContent).products.flatMap(product => product.variants); }
   catch { variants = []; }
  }
  let frame = 0;
  const setText = (node, value) => { if (node.textContent !== value) node.textContent = value; };
  function editorIncomplete() {
   const id = document.getElementById(professional ? 'mm-variant-id' : 'variant-id')?.value;
   const variant = variants.find(item => String(item.id) === id);
   return !!variant?.available && form.querySelector('input[name="designMode"]:checked')?.value === 'editor' && !window.RIDesigner?.ready();
  }
  function sync() {
   frame = 0;
   const text = total.textContent.trim();
   const pending = !/\d/.test(text);
   const count = Math.min(99, Math.max(1, Math.trunc(Number(quantity?.value) || 1)));
   const nativeText = nativeButton.textContent.trim();
   const busy = /ekleniyor/i.test(nativeText);
   const editor = editorIncomplete();
   setText(price, pending ? 'Fiyat teyidi' : text);
   setText(label, pending ? 'Seçiminiz için' : `${count} adet · KDV dâhil`);
   bar.querySelector('[data-product-bar-details]').setAttribute('aria-label', pending ? 'Fiyat teyidi ve seçim detaylarına git' : `${count} adet, KDV dâhil ${text}. Fiyat ve adet detaylarına git`);
   bar.dataset.pricePending = String(pending);
   setText(action, busy ? 'Ekleniyor…' : editor ? 'Tasarımı tamamla' : nativeButton.disabled ? 'Şu an sunulmuyor' : pending ? 'Fiyat iste' : 'Sepete ekle');
   button.disabled = busy || (nativeButton.disabled && !editor);
   button.setAttribute('aria-busy', String(busy));
   bar.hidden = false;
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(sync); }
  const behavior = () => matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth';
  bar.querySelector('[data-product-bar-details]').addEventListener('click', () => {
   summary.scrollIntoView({behavior:behavior(),block:'center'});
   if (quantity) quantity.focus({preventScroll:true});
  });
  button.addEventListener('click', () => {
   if (!mobile.matches || button.disabled) return;
   if (editorIncomplete()) {
    window.RIDesigner?.validate();
    const opener = [...form.querySelectorAll('[data-open-designer]')].find(node => node.getClientRects().length);
    if (opener) { opener.scrollIntoView({behavior:behavior(),block:'center'}); opener.focus({preventScroll:true}); }
    return;
   }
   // Reuse the native button: the existing form owns validation, uploaded files,
   // variant selection, duplicate-submit protection and the cart request.
   if (!nativeButton.disabled) nativeButton.click();
   schedule();
  });
  new MutationObserver(schedule).observe(summary, {subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled']});
  form.addEventListener('change', schedule);
  form.addEventListener('input', schedule);
  form.addEventListener('ri:profession-design-state', schedule);
  form.addEventListener('submit', schedule);
  const resize = new ResizeObserver(() => {
   const height = Math.ceil(bar.getBoundingClientRect().height);
   if (height > 0) document.body.style.setProperty('--ri-product-bar-height',`${height}px`);
  });
  resize.observe(bar);
  mobile.addEventListener('change', schedule);
  bar.dataset.initialized = 'true';
  document.body.classList.add('ri-has-mobile-product-bar');
  sync();
 }
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
 else init();
})();
